/** @format */

import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { getOfflineData } from "../../utils/offline-services";
import { useNavigate } from "react-router-dom";
import Address from "./address";
import Communication from "./communication";
import AddressType from "./address-type";
import CommunicationAddressType from "./communication-type";
import MemoCategory from "./memo-category";
import WaiverType from "./waiver-type";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/login");
    }
  }, []);

  return (
    <Box sx={{ width: "100%", backgroundColor: "white" }}>
      <Box sx={{ pl: 5 }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Address" {...a11yProps(0)} />
          <Tab label="Communication" {...a11yProps(1)} />
          <Tab label="Address Type" {...a11yProps(2)} />
          <Tab label="Communication Address Type" {...a11yProps(3)} />
          <Tab label="Memo Category" {...a11yProps(4)} />
          <Tab label="Waiver Type" {...a11yProps(5)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Address />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Communication />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AddressType />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <CommunicationAddressType />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <MemoCategory />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <WaiverType />
      </TabPanel>
    </Box>
  );
}
